import { useState } from "react";
import genericRepositoryService from "../../../../services/genericRepositoryService";
import { IAutoDetectLanguageRequest } from "../../../../models/IAutoDetectLanguageRequest";

/**
 * Hook for language detection
 * Single Responsibility: Detect language from text
 */
export const useLanguageDetection = () => {
  const [isDetecting, setIsDetecting] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const detectLanguage = async (text: string): Promise<string | null> => {
    if (!text || text.trim() === "") {
      return null;
    }

    setIsDetecting(true);
    setError(null);

    try {
      const request: IAutoDetectLanguageRequest = {
        textToDetectLanguage: text,
      };

      const response = await genericRepositoryService.detectLanguage(request);

      if (response.data.errorMessage) {
        setError(new Error(response.data.errorMessage));
        return null;
      }

      return response.data.detectedLanguage || null;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to detect language";
      setError(new Error(errorMessage));
      console.error("Language detection error:", err);
      return null;
    } finally {
      setIsDetecting(false);
    }
  };

  return {
    detectLanguage,
    isDetecting,
    error,
  };
};
